// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application";
import ClipboardController from "./clipboard_controller";
import ConfettiController from "./confetti_controller";
import FlashMessageController from "./flash_message_controller";
import FormController from "./form_controller";
import RepeaterController from "./repeater_controller";
import TurnstileController from "./turnstile_controller";

application.register("clipboard", ClipboardController);
application.register("confetti", ConfettiController);
application.register("flash-message", FlashMessageController);
application.register("form", FormController);
application.register("repeater", RepeaterController);
application.register("turnstile", TurnstileController);
